import React from 'react';
import SurfaceCard from './SurfaceCard';
import {Box, BoxProps, Heading, HStack, Stack, Text} from 'components/ui/chakra';

interface PageHeaderProps extends BoxProps {
	actions?: React.ReactNode;
	description?: React.ReactNode;
	eyebrow?: React.ReactNode;
	heading: React.ReactNode;
}

const PageHeader = ({actions, description, eyebrow, heading, ...rest}: PageHeaderProps) => (
	<SurfaceCard
		bg='linear-gradient(135deg, rgba(255, 253, 249, 0.98) 0%, rgba(245, 241, 235, 0.92) 100%)'
		p={{base: 5, md: 6}}
		{...rest}
	>
		<Stack direction={{base: 'column', lg: 'row'}} gap={4} justify='space-between'>
			<Box maxW='4xl'>
				{eyebrow && (
					<Text
						color='subtleText'
						fontSize='0.78rem'
						fontWeight='700'
						letterSpacing='0.1em'
						textTransform='uppercase'
					>
						{eyebrow}
					</Text>
				)}
				<Heading as='div' fontSize={{base: '2xl', md: '3xl'}} mt={eyebrow ? 2 : 0}>
					{heading}
				</Heading>
				{description && (
					<Text color='subtleText' fontSize={{base: 'sm', md: 'md'}} mt={3} maxW='3xl'>
						{description}
					</Text>
				)}
			</Box>
			{actions && (
				<HStack alignSelf={{base: 'stretch', lg: 'flex-start'}} flexWrap='wrap' gap={3}>
					{actions}
				</HStack>
			)}
		</Stack>
	</SurfaceCard>
);

export default PageHeader;
